import * as tslib_1 from "tslib";
import * as React from 'react';
import FontIcon from 'material-ui/FontIcon';
import { grey500, grey600 } from 'material-ui/styles/colors';
var styles = {
    input: {
        width: '90%',
        color: grey600,
        display: 'inline-block',
        padding: '1rem',
        cursor: 'pointer'
    },
    icon: {
        float: 'right'
    }
};
var FileUpload = /** @class */ (function (_super) {
    tslib_1.__extends(FileUpload, _super);
    function FileUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFileChange = function (e) {
            e.preventDefault();
            var files = e.target.files;
            if (!files || files.length === 0) {
                return;
            }
            if (_this.props.onChange) {
                _this.props.onChange(files[0]);
            }
        };
        _this.handleFileUpload = function (e) {
            e.preventDefault();
            if (_this.props.onUpload) {
                _this.props.onUpload();
            }
        };
        _this.handleFileClear = function (e) {
            e.preventDefault();
            _this.uploadInput.value = null;
            if (_this.props.onClear) {
                _this.props.onClear();
            }
        };
        return _this;
    }
    FileUpload.prototype.componentWillReceiveProps = function (nextProps) {
        if (!nextProps.selectedFile) {
            this.uploadInput.value = null;
        }
    };
    FileUpload.prototype.render = function () {
        var _this = this;
        var isFileSelected = !!this.props.selectedFile;
        var label = isFileSelected
            ? this.props.selectedFile.name
            : 'Dokumentum csatolása...';
        var clearButton = !isFileSelected
            ? null
            : React.createElement(FontIcon, { title: "T\u00F6rl\u00E9s", className: "material-icons", style: styles.icon, color: grey500, onClick: this.handleFileClear }, "clear");
        var uploadButton = !isFileSelected
            ? null
            : React.createElement(FontIcon, { title: "Felt\u00F6lt\u00E9s", className: "material-icons", style: styles.icon, color: grey500, onClick: this.handleFileUpload }, "file_upload");
        return (React.createElement("div", { className: "create-container" },
            React.createElement("label", { htmlFor: "file-upload", className: "create" },
                label,
                uploadButton,
                clearButton),
            React.createElement("input", { id: "file-upload", ref: function (elem) { return _this.uploadInput = elem; }, type: "file", style: { display: 'none' }, onChange: this.handleFileChange })));
    };
    return FileUpload;
}(React.Component));
export default FileUpload;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/FileUpload.tsx
// module id = 737
// module chunks = 0